import { customStyle, pxToRem } from 'styles/functions'

const Theme = {
  logo_image_url: 'waq.png',
  logo_height: 75,
  number_color: '#000ca0',

  button_half_border_color: '#ffd400',
  button_no_border: true,

  text_font: `'Rajdhani', sans-serif`,
  title_font: `'Rajdhani', sans-serif`,
  title_color: '#000ca0',
  title_shadow: '0 3px 1px rgba(185, 186, 195, 0.5)',

  custom_button: customStyle(`
    position: relative;
    min-width: ${pxToRem(200)};
    padding: 0;
    background-color: transparent;

    label {
      padding: ${pxToRem(20)} ${pxToRem(30)};
      width: 100%;
      border: ${pxToRem(5)} solid #00efb0;
      color: #00efb0;
      border-radius: ${pxToRem(99)};
      background-color: #000ca0;
      transform: translate(0, 0);
    }

    &:before {
      content: '';
      background-color: #00efb0;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: ${pxToRem(99)};
      transform: translate3d(${pxToRem(10)}, ${pxToRem(10)}, 0);
    }
  `),
}

export default Theme
